import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import InfluencerService from "../services/InfluencerService";

import { Input, Button, Tooltip, Tag, Modal, notification,  Popconfirm, Switch } from "antd";

import { EditOutlined, UserOutlined, DeleteOutlined,ExclamationCircleOutlined } from "@ant-design/icons";

import ContentPagination from "../utils/Pagination";
import moment from "moment";
import Notification from "../utils/Notification";

export default function Influencer() {
  const history = useHistory();

  const [data, setData] = useState([]);
  const initialInfluencerState = {
    influencer_id: null,
    name: "",
    updated_by: "",
    created_by: "",
    updated_datetime: null,
    status: null,
  };
  const [influencer, setInfluencer] = useState(initialInfluencerState);
  const [perPage, setPerPage] = useState(10);
  const [searchInfluencer, setSearchInfluencer] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPage] = useState(1);
  const [ModalOpen, setModalOpen] = useState(false);
  const [influencerName, setInfluencerName] = useState();
  const [dataItem, setDataItem] = useState([]);
  const [action, setAction] = useState("");

  const { confirm } = Modal;

  useEffect(() => {
    getData(currentPage, searchInfluencer);
  }, [0]);

  const getData = async (page, filterName) => {
    await InfluencerService.getAll(page, filterName)
      .then((res) => {
        const response = res.data;

        const totalPages = Math.ceil(response.total / perPage);
        setTotalPage(totalPages);
        setData(response.influencers);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  function changePage(page) {
    setCurrentPage(page);
    getData(page, searchInfluencer);
  }

  const onChangeSearchInfluencer = (e) => {
    const searchInfluencer = e.target.value;
    setSearchInfluencer(searchInfluencer);
    getData(currentPage, searchInfluencer);
  };

  const ShowNotification = (type, header, message) =>
    notification[type]({
      message: header,
      description: message,
    });

  function SaveInfluencer() {
    if (!influencerName) {
      Notification.Show("error", "Validation", "กรุณาระบุ Influencer Name");
      return;
    }

    let action_by = "";
    var result = localStorage.getItem("user_profile");
    if (result) action_by = JSON.parse(result).name;
    
    if(action === 'add')
    {
        influencer.influencer_id = null;
    }
    else 
        influencer.influencer_id = dataItem.influencer_id;

    influencer.name = influencerName;

    if (action === 'add') influencer.created_by = action_by;

    influencer.updated_by = action_by;
    influencer.updated_datetime = moment(new Date()).format(
      "YYYY-MM-DD HH:mm:ss"
    );

    if (action === 'add') influencer.status = "A";
    else influencer.status = dataItem.status;

    console.log(influencer);
    if (action === "add") {
      InfluencerService.create(influencer)
        .then((response) => {
          ShowNotification("success", "Success", "บันทึกข้อมูลเรียบร้อยแล้ว");
          setModalOpen(false);
          getData(currentPage, searchInfluencer);
        })
        .catch((e) => {
          console.log(e);
          Notification.Show("error", "Validation", e.response.data.message);
        });
    } else {
      InfluencerService.update(influencer.influencer_id, influencer)
        .then((response) => {
          ShowNotification("success", "Success", "บันทึกข้อมูลเรียบร้อยแล้ว");
          setModalOpen(false);
          getData(currentPage, searchInfluencer);
        })
        .catch((e) => {
          console.log(e);
          Notification.Show("error", "Validation", e.response.data.message);
        });
    }
  }

  async function manageInfluencer(action, data) {
    if (action === 'add') {
        await setAction('add');
        await setInfluencerName("");
    } else {
        setAction('update');
        await setDataItem(data);
        await setInfluencerName(data.name);
    }
    setModalOpen(true);
  }

  const showDeleteConfirm = (id) => {
    confirm({
      title: "Confirm Delete?",
      icon: <ExclamationCircleOutlined />,
      content: "ต้องการลบ Influencer นี้ใช่หรือไม่",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",

      onOk() {
        deleteInfluencer(id);
      },

      onCancel() {
        console.log("Cancel");
      },
    });
  };

  async function deleteInfluencer(id) {
    let response = await InfluencerService.remove(id);
    if (response.status === 200 || response.status === 201) {
      Notification.Show("success", "Success", "ลบ Influencer เรียบร้อยแล้ว");
      getData(currentPage,searchInfluencer);
    } else {
      Notification.Show(
        "error",
        "Error",
        "เกิดข้อผิดพลาดในการบันทึกข้อมูล กรุณาลองใหม่อีกครั้ง"
      );
    }
  }

  async function handleChange(item) {
    let newStatus = null;

    newStatus = item.status === 'A' ? 'I' : 'A';

    let newData = data;

    newData.map((newData) => {
      if (newData.influencer_id === item.influencer_id) {
        newData.status = newStatus;
      }
    });

    let action_by = "";
    var result = localStorage.getItem("user_profile");
    if (result) action_by = JSON.parse(result).name;
    
    influencer.influencer_id = item.influencer_id;
    influencer.status = newStatus;

    influencer.updated_by = action_by;
    influencer.updated_datetime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");

    await InfluencerService.updateStatus(influencer.influencer_id, influencer)
      .then((response) => {
        getData(currentPage, searchInfluencer);
      })
      .catch((e) => {
        console.error(e.response.data.message);
        Notification.Show(
          "error",
          "Error",
          "เกิดข้อผิดพลาดในการบันทึกข้อมูล กรุณาลองใหม่อีกครั้ง"
        );
      });
  }

  return (
    <div className="container">
      <div className="text-right container-fluid">
        <Button
          className="btn-primary px-3"
          onClick={() => {
            manageInfluencer('add', null);
          }}
        >
          เพิ่ม Influencer
        </Button>
      </div>

      <h5 className="mt-2 font-weight-bold">รายชื่อ Influencer</h5>
      <div className="line-highlight">
        <hr />
      </div>

      <div className="flex-fill">
        <div className="form-group mb-0 mt-2">
          <Input
            placeholder="Influencer Name"
            prefix={<UserOutlined />}
            value={searchInfluencer}
            onChange={onChangeSearchInfluencer}
          />
        </div>

        <div class="table_wrapper">
          <table className="table border mb-0 mt-4">
            <thead>
              <tr>
                <th className="text-center">ID</th>
                <th className="text-left">Influencer Name</th>
                <th className="text-center">Status</th>
                <th>แก้ไข</th>
                <th>ลบ</th>
              </tr>
            </thead>
            <tbody>
              {data &&
                data.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td className="text-center font-weight-bold">
                        {item.influencer_id}
                      </td>
                      <td className="text-left font-weight-bold">
                        {item.name}
                      </td>
                      <td className="text-center">
                        <Switch
                          onChange={() => handleChange(item)}
                          checkedChildren="Active"
                          unCheckedChildren="InActive"
                          checked={item.status === 'A' ? true : false}
                        />
                      </td>
                      <td>
                        <Tooltip title="แก้ไข" className="mr-2">
                          <Button
                            type="primary"
                            shape="circle"
                            size="small"
                            className="btn-secondary"
                            icon={<EditOutlined />}
                            onClick={() => {
                              manageInfluencer('update', item);
                            }}
                          />
                        </Tooltip>
                      </td>
                      <td>
                      <Button
                          type="primary"
                          shape="circle"
                          size="small"
                          className="btn-danger"
                          icon={<DeleteOutlined />}
                          onClick={() => showDeleteConfirm(item.influencer_id)}
                        />
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>

        <Modal
          title="Influencer"
          footer={null}
          maskClosable={false}
          visible={ModalOpen}
          onCancel={() => setModalOpen(false)}
        >
          <div className="row">
            <div className="col-12">
              <label>
                Influencer Name
                <span className="text-danger">*</span>
              </label>
              <Input
                value={influencerName}
                onChange={(e) => setInfluencerName(e.target.value)}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-6"></div>

            <div className="col-6">
              <div className="mt-2 text-right">
                <button
                  type="button"
                  className="btn btn-secondary mr-2"
                  onClick={() => {
                    setModalOpen(false);
                  }}
                >
                  ยกเลิก
                </button>
                <button
                  type="button"
                  onClick={() => {
                    SaveInfluencer();
                  }}
                  className="btn btn-primary mr-2"
                >
                  ยืนยัน
                </button>
              </div>
            </div>
          </div>
        </Modal>

        <div className="text-right mt-4">
          {data && data.length > 0 && (
            <ContentPagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={changePage.bind(this)}
              pageShow={10}
            />
          )}
        </div>
      </div>
    </div>
  );
}
